import { jsx as a, jsxs as s, Fragment as S } from "react/jsx-runtime";
import { useModalOverlay as T, Overlay as F } from "@react-aria/overlays";
import n from "classnames";
import { useState as V, useRef as j, useEffect as g, isValidElement as C } from "react";
import { useOverlayTriggerState as H } from "react-stately";
import { V as L } from "./VisuallyHidden-42oizZZl.js";
import { B as d } from "./Button-ClBViKhc.js";
import { I as z } from "./Icon-BcAne5bE.js";
import { FocusScope as R } from "@react-aria/focus";
import { useIntl as q } from "react-intl";
import { commonMessages as G } from "./helpers/messages.js";
const J = (e) => {
  Q(e);
}, Q = (e) => {
  typeof e.title != "string" && (e.title ? !e["aria-label"] && !e["aria-labelledby"] && console.error(
    "A modal with a title that is not a string should have an aria-label or aria-labelledby"
  ) : e.closable ? console.error("A closable modal should have a title") : !e["aria-label"] && !e["aria-labelledby"] && console.error(
    "A modal without a title should have an explicit aria-label or aria-labelledby"
  ));
}, ie = (e) => {
  const {
    open: t,
    title: o,
    children: O,
    onClose: r,
    closable: x = !0,
    backdropClosable: N,
    className: c,
    id: w,
    disableHeader: D = !1,
    disableFooter: m = !1,
    okText: b = "OK",
    cancelText: f = "Cancel",
    mobileBehaviour: u = "attach-to-bottom-on-mobile",
    fullScreen: E = !1,
    footerButtons: h,
    onCancel: y,
    onOk: k,
    okColors: v,
    onOkDisabled: B,
    closeOnBackdropClick: M
  } = e;
  J(e);
  const P = q(), [$, A] = V(!1), _ = H({
    isOpen: t,
    onOpenChange: (l) => {
      l || r();
    }
  }), i = j(null), { modalProps: p, underlayProps: I } = T(
    {
      isDismissable: N
    },
    _,
    i
  );
  return g(() => {
    t && i.current && i.current.focus(), A(t);
  }, [t]), g(() => {
    const l = (K) => {
      K.key === "Escape" && t && r();
    };
    return document.addEventListener("keydown", l), () => {
      document.removeEventListener("keydown", l);
    };
  }, [t, r]), _.isOpen ? /* @__PURE__ */ a(F, { children: /* @__PURE__ */ a(
    "div",
    {
      className: n(
        "ds-modal__backdrop",
        `ds-modal__backdrop--${u}`,
        `ds-modal__backdrop--${c}`
      ),
      ...I,
      onClick: M ? r : () => {
      },
      onKeyDown: () => {
      },
      children: /* @__PURE__ */ a(R, { contain: !0, children: /* @__PURE__ */ s(
        "div",
        {
          ref: i,
          tabIndex: -1,
          ...p,
          onClick: (l) => l.stopPropagation(),
          onKeyDown: () => {
          },
          className: n(
            "ds-modal",
            `ds-modal--${u}`,
            {
              "ds-modal--no-footer": m,
              "ds-modal--full-screen": E,
              "ds-modal--animated": $
            },
            c
          ),
          id: n(w, p.id),
          "aria-label": typeof o == "string" ? o : e["aria-label"],
          "aria-labelledby": e["aria-labelledby"],
          "aria-describedby": e["aria-describedby"],
          role: "dialog",
          children: [
            !D && /* @__PURE__ */ s("header", { className: "ds-modal__header", children: [
              o && C(o) && o,
              o && !C(o) && /* @__PURE__ */ a("h2", { children: o }),
              x && /* @__PURE__ */ s(
                "button",
                {
                  type: "button",
                  onClick: r,
                  className: "ds-modal__header__close-button",
                  children: [
                    /* @__PURE__ */ a(
                      z,
                      {
                        path: "close",
                        size: "large",
                        color: "var(--text-main-default)"
                      }
                    ),
                    /* @__PURE__ */ a(L, { children: P.formatMessage(G.close) })
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ a("div", { className: "ds-modal__content", children: O }),
            !m && /* @__PURE__ */ a("div", { className: "ds-modal__footer", children: h ? h.map((l) => /* @__PURE__ */ a(
              d,
              {
                ...l
              },
              `${l.label ?? "button"}-${l.variant ?? "default"}`
            )) : /* @__PURE__ */ s(S, { children: [
              f && /* @__PURE__ */ a(
                d,
                {
                  variant: "secondary",
                  label: f,
                  onPress: () => {
                    y && y(), r();
                  }
                }
              ),
              b && /* @__PURE__ */ a(
                d,
                {
                  variant: v ? "custom" : "primary",
                  colors: v,
                  label: b,
                  onPress: () => {
                    k && k(), r();
                  },
                  disabled: B
                }
              )
            ] }) })
          ]
        }
      ) })
    }
  ) }) : null;
};
export {
  ie as M
};
//# sourceMappingURL=Modal-ZoeQxXVj.js.map
